/**
 * 显示模态弹窗
 *
 * @param content 提示的标题
 */
export function showConfirm(content: string) {
  return new Promise((resolve, reject) => {
    uni.showModal({
      title: '提示',
      content,
      cancelText: '取消',
      confirmText: '确定',
      success: function (res) {
        resolve(res)
      },
    })
  })
}

/**
 * 显示消息提示框
 *
 * @param content 提示的标题
 */
export function toast(content: string) {
  uni.showToast({
    title: content,
    icon: 'none',
  })
}

/**
 * 参数处理
 * @param params 参数
 */
export function tansParams(params: any) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    const part = encodeURIComponent(propName) + '='
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
            const params = propName + '[' + key + ']'
            const subPart = encodeURIComponent(params) + '='
            result += subPart + encodeURIComponent(value[key]) + '&'
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&'
      }
    }
  }
  return result
}
